import { createCircleIcon } from '../createIcon.tsx';

export const InfoIcon = createCircleIcon(
	'InfoIcon',
	<>
		<line x1="12" y1="16" x2="12" y2="12" />
		<line x1="12" y1="8" x2="12.01" y2="8" />
	</>,
);
